const v35 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          'Finance Account Number': true,
        },
      },
    },
  };
};

export default v35;
